import { CampaignManagementQuery } from "../../../../services/query";
import { CampaignStatus } from "../../../../types/enums/campaign-enums";
import { StoreActionType as Type } from "../../types";

export const getMatrixList : any = (regionId : number) => {
    return async (dispatch: any) => {
        dispatch({ type: Type.GET_CAMPAIGN_MATRIX_REQUEST});

        CampaignManagementQuery.GetMatrixList({ regionId })
            .then((response: any) => {
                if (response) {
                    dispatch({ type: Type.GET_CAMPAIGN_MATRIX_SUCCESS, payload: response.data });
                } else {
                    dispatch({ type: Type.GET_CAMPAIGN_MATRIX_FAILURE, payload: [] });
                }
            })
            .catch((error: any) => {
                console.error('Error:', error);
                dispatch({ type: Type.GET_CAMPAIGN_MATRIX_FAILURE, payload: error });
            });
    }
};

export const setMatrixCampaigns = (campaigns: any[]) => {
    return (dispatch: any) => {
        dispatch({ type: Type.SET_CAMPAIGN_MATRIX_CAMPAIGN_FILTER, payload: campaigns });
    };
}

export const setLiveCampaign = (status: CampaignStatus) => {
    return (dispatch: any) => {
        dispatch({ type: Type.SET_CAMPAIGN_LIVE_CAMPAIGN_FILTER, payload: status });
    };
}
